import { API_URL } from '../config/connect';

const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
    };
};

export const getOrders = async (status = null) => {
    const token = localStorage.getItem('access_token');
    if (!token) throw new Error('Access token missing');

    let url = `${API_URL}/api/v1/orders/`;
    if (status) url += `?status=${status}`;

    const res = await fetch(url, { headers: getAuthHeaders() });
    if (!res.ok) throw new Error(`Error ${res.status}`);
    return res.json();
};

export const getOrderById = async (orderId) => {
    const res = await fetch(`${API_URL}/api/v1/orders/${orderId}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error(`Error ${res.status}`);
    return res.json();
};

export const getOrderHistory = async (orderId) => {
    const res = await fetch(`${API_URL}/api/v1/orders/${orderId}/history`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error(`Error ${res.status}`);
    return res.json();
};
